import React from 'react';
import {
    Stack,
} from '@shopify/polaris';
import ProductConditionItem from '../../../components/ProductConditionItem';
import { ProductAttributePathSettings } from '../../../common/FieldFilters';
import FieldFilterComponent from './FieldFilterComponent';

function FieldFilterListComponent(props) {

    function handleComparisonChange(filter, index, newValue) {

        filter.comparison = newValue;

        props.onFilterUpdated(filter.id, filter);
    }

    function handleValueChange(filter, index, newValue) {
        filter.value = newValue;
        props.onFilterUpdated(filter.id, filter);
    }

    let conditionElements = props.filters.map((filter, index) => {

        let label = ProductAttributePathSettings[filter.fieldPath].label;

        return <ProductConditionItem
            key={filter.id}
            number={index + 1}
            error={filter.error}
            onDelete={() => props.onFilterDelete(index)}>
            <Stack alignment="center" spacing="tight">
                <Stack.Item>
                    {label}
                </Stack.Item>
                <Stack.Item fill>
                    <FieldFilterComponent
                        fieldPath={filter.fieldPath}
                        comparison={filter.comparison}
                        value={filter.value}
                        onComparisonChange={(newValue) => handleComparisonChange(filter, index, newValue)}
                        onValueChange={(newValue) => handleValueChange(filter, index, newValue)}
                    />
                </Stack.Item>
            </Stack>
        </ProductConditionItem>
    }
    );

    return (
        <React.Fragment>
            {conditionElements}
        </React.Fragment>
    );
}

FieldFilterListComponent.defaultProps = {
    errors: []
}

export default FieldFilterListComponent;